module.exports = __webpack_public_path__ + "img/img_sb_jl.b2fe4359.png";